<template>
  <ion-app>
    <ion-content>
      <Loading :active.sync="isLoading" :is-page="fullPage"></Loading>
      <ion-grid>
        <div :class="notification.class">
          <ion-icon mode="ios" name="alert" class="mr-2 mt-0"></ion-icon>
          <p class="mb-0 mt-0">{{ notification.message }}</p>
        </div>
        <div :class="banner.class">
          <div class="close-banner cursor-pointer" @click="hideNutritionalTable">
            <ion-icon name="close"></ion-icon>
          </div>
          <div class="banner-content-relative pt-3">
            <p class="mb-2 text-lg ion-text-left">{{ dessertInfo.namePT }}</p>
            <p
              v-if="user"
              class="mb-4 text-sm grey ion-text-left"
            >Valores de referência (%VR) baseados na sua dieta</p>
            <p
              v-else
              class="mb-4 text-sm grey ion-text-left"
            >Valores de referência (%VR) baseados em uma dieta de 2000 kcal definida pela OMS</p>
            <table class="ion-text-left text-sm">
              <thead class="bg-green white">
                <th class="p-2">Componente</th>
                <th class="p-2">Valor</th>
                <th class="p-2">% VR</th>
              </thead>
              <tbody>
                <tr class="border-tr">
                  <td class="p-2 bold">Calorias</td>
                  <td class="p-2 bold">{{dessertInfo.kcal.value}}</td>
                  <td class="p-2 bold">{{dessertInfo.kcal.prop}}</td>
                </tr>
                <tr>
                  <td class="p-2 bold">Carboidratos totais</td>
                  <td class="p-2 bold">{{dessertInfo.carbs.value}}</td>
                  <td class="p-2 bold">{{dessertInfo.carbs.prop}}</td>
                </tr>
                <tr>
                  <td class="p-2">Açúcares</td>
                  <td class="p-2">{{dessertInfo.sugar.value}}</td>
                  <td class="p-2">{{dessertInfo.sugar.prop}}</td>
                </tr>
                <tr class="border-tr">
                  <td class="p-2">Fibras alimentares</td>
                  <td class="p-2">{{dessertInfo.fibers.value}}</td>
                  <td class="p-2">{{dessertInfo.fibers.prop}}</td>
                </tr>
                <tr class="border-tr">
                  <td class="p-2 bold">Proteína</td>
                  <td class="p-2 bold">{{dessertInfo.protein.value}}</td>
                  <td class="p-2 bold">{{dessertInfo.protein.prop}}</td>
                </tr>
                <tr>
                  <td class="p-2 bold">Gorduras totais</td>
                  <td class="p-2 bold">{{dessertInfo.fat.value}}</td>
                  <td class="p-2 bold">{{dessertInfo.fat.prop}}</td>
                </tr>
                <tr>
                  <td class="p-2">Gorduras saturadas</td>
                  <td class="p-2">{{dessertInfo.saturatedFat.value}}</td>
                  <td class="p-2">{{dessertInfo.saturatedFat.prop}}</td>
                </tr>
                <tr class="border-tr">
                  <td class="p-2">Gorduras trans</td>
                  <td class="p-2">{{dessertInfo.transFat.value}}</td>
                  <td class="p-2">{{dessertInfo.transFat.prop}}</td>
                </tr>
                <tr class="border-tr">
                  <td class="p-2">Vitamina A</td>
                  <td class="p-2">{{dessertInfo.vitA.value}}</td>
                  <td class="p-2">{{dessertInfo.vitA.prop}}</td>
                </tr>
                <tr class="border-tr">
                  <td class="p-2">Vitamina C</td>
                  <td class="p-2">{{dessertInfo.vitC.value}}</td>
                  <td class="p-2">{{dessertInfo.vitC.prop}}</td>
                </tr>
                <tr class="border-tr">
                  <td class="p-2">Cálcio</td>
                  <td class="p-2">{{dessertInfo.calcium.value}}</td>
                  <td class="p-2">{{dessertInfo.calcium.prop}}</td>
                </tr>
                <tr class="border-tr">
                  <td class="p-2">Ferro</td>
                  <td class="p-2">{{dessertInfo.iron.value}}</td>
                  <td class="p-2">{{dessertInfo.iron.prop}}</td>
                </tr>
              </tbody>
            </table>
            <p class="mt-3 text-xs grey ion-text-left">Fonte: Wolfram Alpha</p>
          </div>
        </div>
        <ion-row>
          <ion-col size="12">
            <p class="arrow-back-header mt-0 mb-1 ion-text-uppercase thin dark text-sm">
              <ion-icon
                mode="ios"
                name="arrow-dropleft-circle"
                class="mr-1 text-md cursor-pointer"
                color="primary"
                @click="gotoBack"
              ></ion-icon>
              {{ mealName }}
            </p>
            <p class="mt-0 mb-0 text-xxl green ion-text-uppercase">Sobremesas indicadas</p>
          </ion-col>
        </ion-row>
        <ion-row class="pt-3">
          <ion-col size="12">
            <div
              class="desserts mt-2"
              v-for="dessert in desserts"
              :key="dessert.index"
              @click="showNutritionalTable(dessert.id)"
            >
              <div class="dessert pt-0 pb-0 mb-2 cursor-pointer">
                <ion-item lines="none" no-padding>
                  <ion-avatar slot="start" class="dish-avatar">
                    <ion-img v-if="dessert.data.picture" :src="dessert.data.picture"></ion-img>
                    <ion-img
                      v-else
                      src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/dish_grey.svg?alt=media&token=a4cfabaa-54e0-458f-858b-507f74630d1c"
                    ></ion-img>
                  </ion-avatar>
                  <ion-label>
                    <p class="mt-0 mb-0 ion-text-uppercase text-xs">
                      {{ dessert.data.kcal }} kcal
                      <span class="grey">/ {{ dessert.data.unitName }}</span>
                    </p>
                    <p class="mt-0 mb-0 dark text-sm bold ion-text-wrap">{{ dessert.data.namePT }}</p>
                  </ion-label>
                </ion-item>
                <div class="dish-icon">
                  <ion-icon mode="ios" name="eye" color="primary"></ion-icon>
                </div>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-app>
</template>

<script>
// firebase
import db from "@/firebase/init";
import firebase from "firebase";
// loading
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// store
import store from "../../utils/store.js";
// component
export default {
  name: "MealPlan",
  components: {
    Loading
  },
  data() {
    return {
      notification: {
        class: "error-message p-3 d-none",
        message: null
      },
      isLoading: true,
      fullPage: true,
      banner: {
        class: "banner-message p-3 d-none"
      },
      user: store.state.user,
      profile: store.state.profile,
      desserts: [],
      mealName: null,
      dessertInfo: {
        namePT: null,
        kcal: {
          value: 0,
          prop: 0
        },
        fat: {
          value: 0,
          prop: 0
        },
        saturatedFat: {
          value: 0,
          prop: 0
        },
        transFat: {
          value: 0,
          prop: 0
        },
        carbs: {
          value: 0,
          prop: 0
        },
        sugar: {
          value: 0,
          prop: 0
        },
        fibers: {
          value: 0,
          prop: 0
        },
        protein: {
          value: 0,
          prop: 0
        },
        vitA: {
          value: 0,
          prop: 0
        },
        vitC: {
          value: 0,
          prop: 0
        },
        calcium: {
          value: 0,
          prop: 0
        },
        iron: {
          value: 0,
          prop: 0
        }
      },
      target: {
        kcal: 0,
        fat: 0,
        saturatedFat: 0,
        transFat: 0,
        carbs: 0,
        sugar: 0,
        fibers: 0,
        protein: 0,
        vitA: 0,
        vitC: 0,
        calcium: 0,
        iron: 0
      }
    };
  },
  methods: {
    gotoBack() {
      this.$router.go(-1);
    },
    showNutritionalTable(id) {
      const instance = this;
      const desserts = instance.desserts;
      let dessertChosen;
      for (let i = 0; i < desserts.length; i++) {
        if (desserts[i].id === id) {
          dessertChosen = desserts[i];
        }
      }
      instance.dessertInfo = {
        namePT: dessertChosen.data.namePT,
        kcal: {
          value: `${Math.round(dessertChosen.data.kcal)} kcal`,
          prop: `${Math.round(
            (dessertChosen.data.kcal / instance.target.kcal) * 100
          )} %`
        },
        fat: {
          value: `${Math.round(dessertChosen.data.fat / 1000)} g`,
          prop: `${Math.round(
            (dessertChosen.data.fat / instance.target.fat) * 100
          )} %`
        },
        saturatedFat: {
          value: `${Math.round(dessertChosen.data.saturatedFat / 1000)} g`,
          prop: `${Math.round(
            (dessertChosen.data.saturatedFat / instance.target.saturatedFat) *
              100
          )} %`
        },
        transFat: {
          value: `${dessertChosen.data.transFat} mg`,
          prop: "-"
        },
        cholesterol: {
          value: `${dessertChosen.data.cholesterol} mg`,
          prop: `${Math.round(
            (dessertChosen.data.cholesterol / instance.target.cholesterol) * 100
          )} %`
        },
        sodium: {
          value: `${Math.round(dessertChosen.data.sodium / 1000)} mg`,
          prop: `${Math.round(
            (dessertChosen.data.sodium / instance.target.sodium) * 100
          )} %`
        },
        carbs: {
          value: `${Math.round(dessertChosen.data.carbs / 1000)} g`,
          prop: `${Math.round(
            (dessertChosen.data.carbs / instance.target.carbs) * 100
          )} %`
        },
        fibers: {
          value: `${Math.round(dessertChosen.data.fibers / 1000)} g`,
          prop: `${Math.round(
            (dessertChosen.data.fibers / instance.target.fibers) * 100
          )} %`
        },
        sugar: {
          value: `${Math.round(dessertChosen.data.sugar / 1000)} g`,
          prop: `${Math.round(
            (dessertChosen.data.sugar / instance.target.sugar) * 100
          )} %`
        },
        protein: {
          value: `${Math.round(dessertChosen.data.protein / 1000)} g`,
          prop: `${Math.round(
            (dessertChosen.data.protein / instance.target.protein) * 100
          )} %`
        },
        vitA: {
          value: `${dessertChosen.data.vitA} ng`,
          prop: `${Math.round(
            (dessertChosen.data.vitA / instance.target.vitA) * 100
          )} %`
        },
        vitC: {
          value: `${dessertChosen.data.vitC} mg`,
          prop: `${Math.round(
            (dessertChosen.data.vitC / instance.target.vitC) * 100
          )} %`
        },
        calcium: {
          value: `${dessertChosen.data.calcium} mg`,
          prop: `${Math.round(
            (dessertChosen.data.calcium / instance.target.calcium) * 100
          )} %`
        },
        iron: {
          value: `${dessertChosen.data.iron} ng`,
          prop: `${Math.round(
            (dessertChosen.data.iron / instance.target.iron) * 100
          )} %`
        }
      };
      this.banner = {
        class: "banner-message p-3"
      };
    },
    hideNutritionalTable() {
      this.banner = {
        class: "banner-message p-3 d-none"
      };
    }
  },
  async created() {
    const instance = this;
    await store.signinUser();
    instance.user = store.state.user;
    instance.profile = store.state.profile;
    try {
      let ref;
      if (instance.$route.params.meal === "breakfast") {
        ref = db.collection("desserts").where("breakfast", "==", true);
        instance.mealName = "Café-da-manhã";
      } else if (instance.$route.params.meal === "lunch") {
        ref = db.collection("desserts").where("breakfast", "==", true);
        instance.mealName = "Almoço";
      } else if (instance.$route.params.meal === "dinner") {
        ref = db.collection("desserts").where("breakfast", "==", true);
        instance.mealName = "Jantar";
      } else {
        ref = db.collection("desserts");
        instance.mealName = "Lanche / Ceia";
      }
      const snapshot = await ref.get();
      let desserts = [];
      snapshot.forEach(doc => {
        const dessertObj = {
          id: doc.id,
          data: doc.data()
        };
        desserts.push(dessertObj);
      });
      desserts.sort(function(a, b) {
        const textA = a.data.namePT.toUpperCase();
        const textB = b.data.namePT.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      instance.desserts = desserts;
      instance.target.kcal = 2000;
      instance.target.fat = 78000;
      instance.target.saturatedFat = 200000;
      instance.target.cholesterol = 300;
      instance.target.carbs = 275000;
      instance.target.sugar = 50000;
      instance.target.fibers = 28000;
      instance.target.protein = 50000;
      instance.target.sodium = 2300000;
      instance.target.vitA = 900;
      instance.target.vitC = 90;
      instance.target.calcium = 1300;
      instance.target.iron = 1800;
      if (instance.user) {
        instance.target.kcal = instance.profile.data.target.kcal;
        instance.target.kcal = instance.profile.data.target.fat;
        instance.target.kcal = instance.profile.data.target.saturatedFat;
        instance.target.kcal = instance.profile.data.target.cholesterol;
        instance.target.kcal = instance.profile.data.target.carbs;
        instance.target.kcal = instance.profile.data.target.sugar;
        instance.target.kcal = instance.profile.data.target.fibers;
        instance.target.kcal = instance.profile.data.target.protein;
        instance.target.kcal = instance.profile.data.target.sodium;
        instance.target.kcal = instance.profile.data.target.vitA;
        instance.target.kcal = instance.profile.data.target.vitC;
        instance.target.kcal = instance.profile.data.target.calcium;
        instance.target.kcal = instance.profile.data.target.iron;
      }
      instance.isLoading = false;
    } catch (e) {
      console.log(e);
      instance.isLoading = false;
    }
  }
};
</script>

<style scoped>
ion-app {
  background: var(--bg-color-light) !important;
}
ion-content {
  --padding-bottom: 50px;
  --background: transparent !important;
}
ion-item {
  --padding-start: 10px;
}
.dessert {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 70px !important;
  width: 100%;
  border-radius: 15px !important;
  background: white;
  box-shadow: 0 12px 6px -3px rgba(0, 0, 0, 0.15);
  padding-right: 15px;
}
.dessert-avatar {
  height: 50px;
  width: 50px;
}
.dessert-icon {
  width: 1.75rem;
}
.dessert ion-icon {
  font-size: 1.75rem;
}
.dessert {
  position: relative;
  width: 100%;
  border-radius: 50px;
  background: white;
  box-shadow: 0 12px 6px -3px rgba(0, 0, 0, 0.15);
}
.arrow-back-header {
  display: flex;
  align-items: center;
}
.banner-message {
  overflow-y: scroll;
  background: #f7f7f7;
  box-shadow: 0 -12px -6px 3px rgba(0, 0, 0, 0.15);
}

.close-banner {
  position: fixed;
  top: 50px;
  right: 20px;
  z-index: 1001;
  font-size: 2rem;
}

.banner-content-relative table {
  width: 100%;
  overflow: none;
}

.border-tr {
  border-bottom: 1px solid lightgrey;
}
</style>
